<template>
  <div class="pa-4 curva-desgaste-wrapper">
    <!-- Botón Volver -->
    <v-btn @click="$router.back()" class="back-btn mb-3">
      <v-icon left>mdi-arrow-left</v-icon>
      VOLVER
    </v-btn>

    <v-col cols="12" class="pa-0">
      <v-card class="modern-report-card elevation-2">
        <!-- Header moderno con gradiente y botón de ayuda (Estilo ReporteCurvaDesgasteNeumatico) -->
        <div class="report-header-banner">
          <div class="d-flex align-center header-main-info">
            <div class="header-icon-box mr-3 flex-shrink-0">
              <v-icon color="white">mdi-truck-outline</v-icon>
            </div>
            <div class="header-text-block">
              <div class="font-weight-bold white--text header-company-title">
                Curva de Desgaste de Vehículo
              </div>
              <div class="header-report-subtitle">
                {{
                  Cliente && Cliente.razon_social
                    ? Cliente.razon_social + " — "
                    : ""
                }}Análisis de remanente, controles y costos acumulados
              </div>
            </div>
          </div>

          <div
            class="header-help-btn ml-auto flex-shrink-0 d-flex align-center"
          >
            <!-- Chip del vehículo activo en el header -->
            <v-chip
              v-if="datosVehiculosCargados && Vehiculo && Vehiculo.placa"
              small
              class="d-none d-sm-inline-flex mr-2 vehicle-header-chip"
            >
              <v-icon left x-small color="amber lighten-2">mdi-truck</v-icon>
              Placa: <strong>{{ Vehiculo.placa }}</strong>
            </v-chip>

            <!-- Botón de ayuda -->
            <v-tooltip left>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  class="mx-1 btn-circle-tooltip"
                  icon
                  dark
                  target="_blank"
                  :href="helpdeskUrl + 'curva-desgaste-vehiculo'"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon size="22" color="amber lighten-2"
                    >mdi-help-circle-outline</v-icon
                  >
                </v-btn>
              </template>
              <span>¿Necesitas ayuda?</span>
            </v-tooltip>
          </div>
        </div>

        <!-- Cuerpo del Reporte -->
        <v-card-text class="pa-4 pa-md-5">
          <!-- 1. Card de Selector y Ficha Técnica del Vehículo -->
          <v-card
            class="dashboard-chart-card rounded-lg pa-0 overflow-hidden elevation-1 mb-5"
          >
            <div
              class="chart-subtitle-bar px-4 py-2 d-flex align-center justify-space-between flex-wrap"
            >
              <div class="d-flex align-center">
                <v-icon small color="primary" class="mr-2"
                  >mdi-truck-search</v-icon
                >
                <span
                  class="font-weight-bold text-caption text-uppercase text--primary"
                >
                  Selección de Vehículo
                </span>
              </div>
              <div
                v-if="datosVehiculosCargados && Vehiculo && Vehiculo.placa"
                class="d-flex align-center"
              >
                <v-chip
                  small
                  color="primary lighten-4"
                  class="primary--text font-weight-bold"
                >
                  <v-icon left x-small>mdi-tag</v-icon>
                  Placa: {{ Vehiculo.placa }}
                </v-chip>
              </div>
            </div>

            <div class="pa-4">
              <v-row align="center">
                <v-col cols="12" sm="8" md="5" lg="4">
                  <v-autocomplete
                    outlined
                    dense
                    hide-details="auto"
                    prepend-inner-icon="mdi-truck"
                    @change="onSeleccionarVehiculo"
                    :items="Vehiculos"
                    label="Seleccione vehículo *"
                    placeholder="Buscar por placa o código..."
                    v-model="VehiculoSeleccionado"
                    clearable
                    class="field-custom"
                  ></v-autocomplete>
                </v-col>
              </v-row>

              <!-- Ficha técnica del vehículo seleccionado -->
              <div
                v-if="datosVehiculosCargados"
                class="mt-4 pt-3 border-top-light"
              >
                <div class="d-flex align-center mb-2">
                  <v-icon x-small color="primary" class="mr-1"
                    >mdi-card-bulleted-outline</v-icon
                  >
                  <span
                    class="text-caption font-weight-bold text-uppercase text--secondary"
                  >
                    Ficha Técnica de la Unidad
                  </span>
                </div>
                <v-row dense>
                  <!-- Marca -->
                  <v-col cols="6" sm="4" md="3" lg="2">
                    <div class="tire-spec-box">
                      <div class="spec-label">
                        <v-icon x-small color="grey darken-1" class="mr-1"
                          >mdi-tag-outline</v-icon
                        >
                        MARCA
                      </div>
                      <div
                        class="spec-value text-truncate"
                        :title="Vehiculo.marca"
                      >
                        {{ Vehiculo.marca || "-" }}
                      </div>
                    </div>
                  </v-col>
                  <!-- Modelo -->
                  <v-col cols="6" sm="4" md="3" lg="2">
                    <div class="tire-spec-box">
                      <div class="spec-label">
                        <v-icon x-small color="grey darken-1" class="mr-1"
                          >mdi-tag-outline</v-icon
                        >
                        MODELO
                      </div>
                      <div
                        class="spec-value text-truncate"
                        :title="Vehiculo.modelo"
                      >
                        {{ Vehiculo.modelo || "-" }}
                      </div>
                    </div>
                  </v-col>

                  <!-- Tipo -->
                  <v-col cols="6" sm="4" md="3" lg="2">
                    <div class="tire-spec-box">
                      <div class="spec-label">
                        <v-icon x-small color="grey darken-1" class="mr-1"
                          >mdi-truck-cargo-container</v-icon
                        >
                        TIPO
                      </div>
                      <div
                        class="spec-value text-truncate"
                        :title="Vehiculo.tipo"
                      >
                        {{ Vehiculo.tipo || "-" }}
                      </div>
                    </div>
                  </v-col>

                  <!-- Aplicación -->
                  <v-col cols="6" sm="4" md="3" lg="2">
                    <div class="tire-spec-box">
                      <div class="spec-label">
                        <v-icon x-small color="grey darken-1" class="mr-1"
                          >mdi-road-variant</v-icon
                        >
                        APLICACIÓN
                      </div>
                      <div
                        class="spec-value text-truncate"
                        :title="Vehiculo.aplicacion"
                      >
                        {{ Vehiculo.aplicacion || "-" }}
                      </div>
                    </div>
                  </v-col>

                  <!-- Tipo Costo -->
                  <!-- <v-col cols="6" sm="4" md="3" lg="2">
                    <div class="tire-spec-box">
                      <div class="spec-label">
                        <v-icon x-small color="grey darken-1" class="mr-1"
                          >mdi-currency-usd</v-icon
                        >
                        TIPO COSTO
                      </div>
                      <div
                        class="spec-value text-truncate"
                        :title="Vehiculo.tipo_costo"
                      >
                        {{ Vehiculo.tipo_costo == 1 ? "KILÓMETROS" : "HORAS" }}
                      </div>
                    </div>
                  </v-col> -->

                  <!-- Km / Hr Inicial -->
                  <v-col cols="6" sm="4" md="3" lg="2">
                    <div class="tire-spec-box">
                      <div class="spec-label">
                        <v-icon x-small color="grey darken-1" class="mr-1"
                          >mdi-counter</v-icon
                        >
                        {{ labelKilometrajeInicial }}
                      </div>
                      <div class="spec-value font-weight-bold text-truncate">
                        {{ parseNumber(Vehiculo.km_inicial) }}
                      </div>
                    </div>
                  </v-col>

                  <!-- Km / Hr Actual -->
                  <v-col cols="6" sm="4" md="3" lg="2">
                    <div class="tire-spec-box">
                      <div class="spec-label">
                        <v-icon x-small color="grey darken-1" class="mr-1"
                          >mdi-speedometer</v-icon
                        >
                        {{ labelKilometrajeActual }}
                      </div>
                      <div
                        class="spec-value font-weight-bold primary--text text-truncate"
                      >
                        {{ parseNumber(Vehiculo.km_actual) }}
                      </div>
                    </div>
                  </v-col>

                  <!-- Km / Hr Recorrido -->
                  <!-- <v-col cols="6" sm="4" md="3" lg="2">
                    <div class="tire-spec-box">
                      <div class="spec-label">
                        <v-icon x-small color="grey darken-1" class="mr-1">mdi-map-marker-distance</v-icon>
                        {{ labelKilometrajeRecorrido }}
                      </div>
                      <div class="spec-value font-weight-bold teal--text text--darken-2 text-truncate">
                        {{ parseNumber(Vehiculo.km_recorrido) }}
                      </div>
                    </div>
                  </v-col> -->
                </v-row>
              </div>
            </div>
          </v-card>

          <!-- Estado 1: Cargando datos del vehículo -->
          <div
            v-if="cargandoVehiculo"
            class="chart-loading-state rounded-lg pa-10 d-flex flex-column align-center justify-center text-center my-4"
          >
            <v-progress-circular
              indeterminate
              size="52"
              width="4"
              color="primary"
              class="mb-4"
            ></v-progress-circular>
            <div
              class="text-subtitle-1 font-weight-bold grey--text text--darken-3 mb-1"
            >
              Cargando análisis del vehículo...
            </div>
            <div class="text-caption grey--text text--darken-1">
              Generando curva de desgaste, detalle de neumáticos y costos
              acumulados
            </div>
          </div>

          <!-- Estado 2: Sin vehículo seleccionado -->
          <div
            v-else-if="!datosVehiculosCargados"
            class="chart-empty-state rounded-lg pa-8 pa-md-12 d-flex flex-column align-center justify-center text-center my-4"
          >
            <div class="empty-state-icon-circle mb-4">
              <v-icon size="48" color="primary lighten-1"
                >mdi-truck-check-outline</v-icon
              >
            </div>
            <h3 class="text-h6 font-weight-bold grey--text text--darken-3 mb-2">
              Seleccione un vehículo
            </h3>
            <p class="text-body-2 grey--text text--darken-1 max-width-480 mb-4">
              Seleccione un vehículo en el menú superior para desplegar su curva
              de desgaste proyectada, historial de controles por neumático y
              análisis de costos.
            </p>
            <v-chip outlined small color="primary" class="font-weight-medium">
              <v-icon left x-small>mdi-cursor-default-click</v-icon>
              Elija un vehículo para comenzar
            </v-chip>
          </div>

          <!-- Estado 3: Vehículo Seleccionado y Datos Disponibles -->
          <div v-else class="vehicle-report-content">
            <!-- 2. Gráfico de Curva de Desgaste con Controles -->
            <v-card
              class="dashboard-chart-card rounded-lg pa-0 overflow-hidden elevation-1 mb-5"
            >
              <div
                class="chart-subtitle-bar px-4 py-2 d-flex align-center justify-space-between flex-wrap"
              >
                <div class="d-flex align-center py-1">
                  <v-icon small color="primary" class="mr-2"
                    >mdi-chart-line</v-icon
                  >
                  <span
                    class="font-weight-bold text-caption text-uppercase text--primary"
                  >
                    Curva de Desgaste (Remanente vs {{ labelScaleX }})
                  </span>
                  <v-chip
                    x-small
                    color="grey lighten-3"
                    class="ml-2 font-weight-medium grey--text text--darken-2"
                  >
                    Tipo de costo:&nbsp; <strong>{{ labelScaleX }}</strong>
                  </v-chip>
                </div>

                <!-- Switch Inspecciones Anteriores -->
                <div class="d-flex align-center py-1">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <div v-bind="attrs" v-on="on" class="switch-container">
                        <v-switch
                          v-model="switch_inspecciones"
                          hide-details
                          dense
                          class="mt-0 pt-0 modern-switch"
                          color="primary"
                          @change="onSeleccionarVehiculo(id_vehiculo)"
                        >
                          <template v-slot:label>
                            <span
                              class="text-caption font-weight-medium text--secondary"
                            >
                              Mostrar Inspecciones Anteriores
                            </span>
                          </template>
                        </v-switch>
                      </div>
                    </template>
                    <span
                      >Incluir inspecciones de montajes previos del
                      vehículo</span
                    >
                  </v-tooltip>
                </div>
              </div>

              <!-- Contenedor del Gráfico -->
              <div class="pa-4 chart-canvas-container" v-if="visualizarGrafico">
                <GraficoLine
                  :DatosGrafico="DatosGrafico"
                  title="Curva de desgaste"
                  :Labels="Labels"
                  :Labelscale_x="labelScaleX"
                  Labelscale_y="Remanente (mm)"
                ></GraficoLine>
              </div>
            </v-card>

            <!-- 3. Sección Detalle de Neumáticos -->
            <v-card
              class="dashboard-chart-card rounded-lg pa-0 overflow-hidden elevation-1 mb-5"
            >
              <div
                class="chart-subtitle-bar px-4 py-2 d-flex align-center justify-space-between flex-wrap"
              >
                <div class="d-flex align-center py-1">
                  <v-icon small color="primary" class="mr-2">mdi-tire</v-icon>
                  <span
                    class="font-weight-bold text-caption text-uppercase text--primary"
                  >
                    Detalle de Neumáticos del Vehículo
                  </span>
                </div>

                <div class="py-1">
                  <v-btn-toggle
                    v-model="detail_neuma"
                    mandatory
                    rounded
                    group
                    class="status-filter-toggle"
                  >
                    <v-btn
                      :value="[1]"
                      small
                      active-class="status-btn-active--primary"
                      class="status-filter-btn"
                    >
                      <v-icon left x-small>mdi-check-circle-outline</v-icon>
                      Instalados
                    </v-btn>
                    <v-btn
                      :value="[0, 1]"
                      small
                      active-class="status-btn-active--primary"
                      class="status-filter-btn"
                    >
                      <v-icon left x-small>mdi-history</v-icon>
                      Historial
                    </v-btn>
                  </v-btn-toggle>
                </div>
              </div>

              <div class="table-responsive-wrapper">
                <table class="modern-dashboard-table">
                  <thead>
                    <tr>
                      <th class="text-center" style="width: 25%">MONTAJE</th>
                      <th class="text-center" style="width: 30%">
                        MEDIDA Y DISEÑO
                      </th>
                      <th class="text-center" style="width: 25%">N° SERIE</th>
                      <th class="text-center" style="width: 20%">PRECIO ($)</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(item, index) in NeumaticosVehiculo.filter(
                        (value) => detail_neuma.includes(value.activo),
                      )"
                      :key="'det-' + index"
                    >
                      <td class="text-center">
                        <v-chip
                          x-small
                          color="blue-grey lighten-5"
                          class="blue-grey--text text--darken-3 font-weight-bold"
                        >
                          POS {{ item.posicion }}
                        </v-chip>
                      </td>
                      <td class="text-center font-weight-medium">
                        {{ item.medida_neumatico }} {{ item.disenio_neumatico }}
                      </td>
                      <td class="text-center font-weight-bold primary--text">
                        {{ item.num_serie }}
                      </td>
                      <td class="text-center font-weight-medium">
                        ${{ item.precio_neumatico_dolares }}
                      </td>
                    </tr>
                    <tr
                      v-if="
                        NeumaticosVehiculo.filter((value) =>
                          detail_neuma.includes(value.activo),
                        ).length === 0
                      "
                    >
                      <td
                        colspan="4"
                        class="text-center py-4 text-caption grey--text"
                      >
                        No hay neumáticos registrados para el filtro
                        seleccionado.
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </v-card>

            <!-- 4. Sección Controles de Neumáticos (Matriz de Inspecciones) -->
            <v-card
              class="dashboard-chart-card rounded-lg pa-0 overflow-hidden elevation-1 mb-5"
            >
              <div
                class="chart-subtitle-bar px-4 py-2 d-flex align-center justify-space-between flex-wrap"
              >
                <div class="d-flex align-center py-1">
                  <v-icon small color="primary" class="mr-2"
                    >mdi-clipboard-text-clock-outline</v-icon
                  >
                  <span
                    class="font-weight-bold text-caption text-uppercase text--primary"
                  >
                    Controles de Neumáticos
                  </span>
                </div>

                <div class="py-1">
                  <v-btn-toggle
                    v-model="control_neuma"
                    mandatory
                    rounded
                    group
                    class="status-filter-toggle"
                  >
                    <v-btn
                      :value="[1]"
                      small
                      active-class="status-btn-active--primary"
                      class="status-filter-btn"
                    >
                      <v-icon left x-small>mdi-check-circle-outline</v-icon>
                      Instalados
                    </v-btn>
                    <v-btn
                      :value="[0, 1]"
                      small
                      active-class="status-btn-active--primary"
                      class="status-filter-btn"
                    >
                      <v-icon left x-small>mdi-history</v-icon>
                      Historial
                    </v-btn>
                  </v-btn-toggle>
                </div>
              </div>

              <div class="table-responsive-wrapper">
                <table
                  class="modern-dashboard-table modern-matrix-table"
                  v-if="visualizarGrafico"
                >
                  <thead>
                    <tr>
                      <th
                        rowspan="2"
                        class="text-center cell-freeze"
                        style="min-width: 110px"
                      >
                        CONTROL
                      </th>
                      <th
                        rowspan="2"
                        class="text-center"
                        style="min-width: 100px"
                      >
                        FECHA
                      </th>
                      <th
                        rowspan="2"
                        class="text-center"
                        style="min-width: 130px"
                      >
                        RECORRIDO ({{ retornarUnidadMedida() }})
                      </th>
                      <th
                        :colspan="
                          NeumaticosVehiculo.filter((value) =>
                            control_neuma.includes(value.activo),
                          ).length
                        "
                        class="text-center header-matrix-group"
                      >
                        P. GRABADO (mm)
                      </th>
                    </tr>
                    <tr>
                      <th
                        v-for="(item, index) in NeumaticosVehiculo.filter(
                          (value) => control_neuma.includes(value.activo),
                        )"
                        :key="'matrix-head-' + index"
                        class="text-center subheader-tire"
                        style="min-width: 90px"
                      >
                        {{ item.num_serie }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <!-- Fila 1: Montaje inicial -->
                    <tr class="row-montaje">
                      <td class="text-center font-weight-bold cell-freeze">
                        <v-chip
                          x-small
                          color="teal lighten-5"
                          class="teal--text text--darken-3 font-weight-bold"
                        >
                          MONTAJE
                        </v-chip>
                      </td>
                      <td class="text-center">
                        {{ Vehiculo.fecha_instalacion || "-" }}
                      </td>
                      <td class="text-center font-weight-medium">0</td>
                      <td
                        v-for="(item, index) in NeumaticosVehiculo.filter(
                          (value) => control_neuma.includes(value.activo),
                        )"
                        :key="'montaje-val-' + index"
                        class="text-center font-weight-bold"
                      >
                        {{ item.remanente_original_neumatico ?? "-" }}
                      </td>
                    </tr>

                    <!-- Filas de Inspecciones posteriores -->
                    <template v-for="(item, index) in InspeccionesVehiculo">
                      <template
                        v-if="
                          item.arrayneumaticos.length > 0 &&
                          item.arrayneumaticos.some((n) =>
                            control_neuma.includes(n.activo),
                          )
                        "
                      >
                        <tr :key="'control-row-' + index">
                          <td class="text-center font-weight-bold cell-freeze">
                            {{ index + 1 }} CONTROL
                          </td>
                          <td class="text-center">
                            {{ item.fecha_inspeccion }}
                          </td>
                          <td class="text-center font-weight-medium">
                            {{
                              parseNumber(
                                item.km_inspeccion - Vehiculo.km_inicial,
                              )
                            }}
                          </td>
                          <td
                            v-for="(
                              item1, index1
                            ) in item.arrayneumaticos.filter((value) =>
                              control_neuma.includes(value.activo),
                            )"
                            :key="'control-val-' + index1"
                            class="text-center"
                          >
                            <span class="remanente-badge">
                              {{
                                imprimirRemanenteMenorDelVehiculo(item1, index1)
                              }}
                            </span>
                          </td>
                        </tr>
                      </template>
                    </template>
                  </tbody>
                </table>
              </div>
            </v-card>

            <!-- 5. Sección Costos y Rendimientos por Neumáticos -->
            <v-card
              class="dashboard-chart-card rounded-lg pa-0 overflow-hidden elevation-1 mb-5"
            >
              <div
                class="chart-subtitle-bar px-4 py-2 d-flex align-center justify-space-between flex-wrap"
              >
                <div class="d-flex align-center py-1">
                  <v-icon small color="primary" class="mr-2"
                    >mdi-chart-areaspline</v-icon
                  >
                  <span
                    class="font-weight-bold text-caption text-uppercase text--primary"
                  >
                    Costos y Rendimientos por Neumáticos
                  </span>
                </div>

                <div class="py-1">
                  <v-btn-toggle
                    v-model="costo_neuma"
                    mandatory
                    rounded
                    group
                    class="status-filter-toggle"
                  >
                    <v-btn
                      :value="[1]"
                      small
                      active-class="status-btn-active--primary"
                      class="status-filter-btn"
                    >
                      <v-icon left x-small>mdi-check-circle-outline</v-icon>
                      Instalados
                    </v-btn>
                    <v-btn
                      :value="[0, 1]"
                      small
                      active-class="status-btn-active--primary"
                      class="status-filter-btn"
                    >
                      <v-icon left x-small>mdi-history</v-icon>
                      Historial
                    </v-btn>
                  </v-btn-toggle>
                </div>
              </div>

              <div class="table-responsive-wrapper">
                <table
                  class="modern-dashboard-table modern-transposed-table"
                  v-if="visualizarGrafico"
                >
                  <thead>
                    <tr>
                      <th
                        class="text-left font-weight-bold cell-freeze"
                        style="min-width: 220px"
                      >
                        PARÁMETRO / INDICADOR
                      </th>
                      <th
                        v-for="(item, index) in NeumaticosVehiculo.filter(
                          (value) => costo_neuma.includes(value.activo),
                        )"
                        :key="'cost-head-' + index"
                        class="text-center subheader-tire"
                        style="min-width: 100px"
                      >
                        {{ item.num_serie }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td class="text-left font-weight-medium cell-freeze">
                        Remanente actual (mm)
                      </td>
                      <td
                        v-for="(item, index) in NeumaticosVehiculo.filter(
                          (value) => costo_neuma.includes(value.activo),
                        )"
                        :key="'rem-act-' + index"
                        class="text-center font-weight-bold primary--text"
                      >
                        {{ item.min_remanente }}
                      </td>
                    </tr>
                    <tr>
                      <td class="text-left font-weight-medium cell-freeze">
                        Recorrido ({{ retornarUnidadMedida() }})
                      </td>
                      <td
                        v-for="(item, index) in NeumaticosVehiculo.filter(
                          (value) => costo_neuma.includes(value.activo),
                        )"
                        :key="'rec-' + index"
                        class="text-center font-weight-medium"
                      >
                        {{ parseNumber(item.km_recorrido) }}
                      </td>
                    </tr>
                    <tr>
                      <td class="text-left font-weight-medium cell-freeze">
                        Desgaste ({{ retornarUnidadMedida() }}/mm)
                      </td>
                      <td
                        v-for="(item, index) in NeumaticosVehiculo.filter(
                          (value) => costo_neuma.includes(value.activo),
                        )"
                        :key="'desg-' + index"
                        class="text-center font-weight-medium"
                      >
                        {{ parseNumber(calcularValoresSegundaFila(item)) }}
                      </td>
                    </tr>
                    <tr>
                      <td class="text-left font-weight-medium cell-freeze">
                        Rend. Proyectado A
                        {{ Vehiculo.remanente_reencauche }} mm ({{
                          retornarUnidadMedida()
                        }})
                      </td>
                      <td
                        v-for="(item, index) in NeumaticosVehiculo.filter(
                          (value) => costo_neuma.includes(value.activo),
                        )"
                        :key="'rend-proy-' + index"
                        class="text-center font-weight-bold teal--text text--darken-2"
                      >
                        {{ parseNumber(calcularValoresTerceraFila(item)) }}
                      </td>
                    </tr>
                    <tr>
                      <td class="text-left font-weight-medium cell-freeze">
                        Costo/{{ retornarUnidadMedida() }} SIN IGV ($)
                      </td>
                      <td
                        v-for="(item, index) in NeumaticosVehiculo.filter(
                          (value) => costo_neuma.includes(value.activo),
                        )"
                        :key="'costo-unit-' + index"
                        class="text-center font-weight-bold indigo--text text--darken-2"
                      >
                        {{ calcularValoresCuartaFila(item) }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </v-card>

            <!-- 6. Sección Costo por Kilómetro (u Hora) Acumulativo -->
            <v-card
              class="dashboard-chart-card rounded-lg pa-0 overflow-hidden elevation-1 mb-4"
              v-if="CostoKmAcumulado && CostoKmAcumulado.length > 0"
            >
              <div
                class="chart-subtitle-bar px-4 py-2 d-flex align-center justify-space-between flex-wrap"
              >
                <div class="d-flex align-center py-1">
                  <v-icon small color="primary" class="mr-2"
                    >mdi-chart-bell-curve</v-icon
                  >
                  <span
                    class="font-weight-bold text-caption text-uppercase text--primary"
                  >
                    {{ labelCostoPorUnidadAcumulativo }}
                  </span>
                </div>

                <div class="py-1">
                  <v-btn-toggle
                    v-model="costo_km_neuma"
                    mandatory
                    rounded
                    group
                    class="status-filter-toggle"
                  >
                    <v-btn
                      :value="[1]"
                      small
                      active-class="status-btn-active--primary"
                      class="status-filter-btn"
                    >
                      <v-icon left x-small>mdi-check-circle-outline</v-icon>
                      Instalados
                    </v-btn>
                    <v-btn
                      :value="[0, 1]"
                      small
                      active-class="status-btn-active--primary"
                      class="status-filter-btn"
                    >
                      <v-icon left x-small>mdi-history</v-icon>
                      Historial
                    </v-btn>
                  </v-btn-toggle>
                </div>
              </div>
              <!-- Tabla de Costos Acumulados -->
              <div class="table-responsive-wrapper">
                <table class="modern-dashboard-table" v-if="visualizarGrafico">
                  <thead>
                    <tr>
                      <th class="text-center">N° SERIE</th>
                      <th class="text-center">POSICIÓN</th>
                      <th class="text-center">COSTO ORIGINAL ($)</th>
                      <th class="text-center">COSTO REENCAUCHES ($)</th>
                      <th class="text-center">COSTO TOTAL ($)</th>
                      <th class="text-center">{{ labelUnidadAcumulado }}</th>
                      <th class="text-center">
                        COSTO/{{ retornarUnidadMedida() }} ACUM. ($)
                      </th>
                      <th class="text-center">CANT. REENCAUCHES</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(item, index) in costoKmAcumuladoFiltrado"
                      :key="'acum-' + index"
                    >
                      <td class="text-center font-weight-bold primary--text">
                        {{ item.num_serie }}
                      </td>
                      <td class="text-center">
                        <v-chip
                          x-small
                          color="blue-grey lighten-5"
                          class="blue-grey--text text--darken-3 font-weight-bold"
                        >
                          POS {{ item.posicion }}
                        </v-chip>
                      </td>
                      <td class="text-center font-weight-medium">
                        ${{ item.costo_original_base }}
                      </td>
                      <td class="text-center font-weight-medium">
                        ${{ item.costo_reencauches }}
                      </td>
                      <td
                        class="text-center font-weight-bold indigo--text text--darken-2"
                      >
                        ${{ item.costo_total }}
                      </td>
                      <td class="text-center font-weight-bold">
                        {{ parseNumber(item.km_acumulado) }}
                      </td>
                      <td
                        class="text-center font-weight-bold teal--text text--darken-2"
                      >
                        ${{ item.costo_km_acumulado }}
                      </td>
                      <td class="text-center">
                        <v-chip
                          x-small
                          color="grey lighten-3"
                          class="font-weight-bold"
                        >
                          {{ item.cantidad_reencauches }}
                        </v-chip>
                      </td>
                    </tr>
                    <tr v-if="costoKmAcumuladoFiltrado.length === 0">
                      <td
                        colspan="8"
                        class="text-center py-4 text-caption grey--text"
                      >
                        No hay registros de costos para el filtro seleccionado.
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <!-- Sub-tablas de Detalle de Costos por Neumático -->
              <div class="pa-4 bg-light-neutral border-top-light">
                <div class="mb-3 d-flex align-center">
                  <v-icon x-small color="primary" class="mr-1"
                    >mdi-format-list-numbered</v-icon
                  >
                  <span
                    class="text-caption font-weight-bold text-uppercase text--secondary"
                  >
                    Desglose de Ciclo de Vida y Reencauches por Neumático
                  </span>
                </div>

                <div
                  v-for="(item, index) in costoKmAcumuladoFiltrado"
                  :key="'detalle-box-' + index"
                  class="cost-detail-subcard mb-4"
                  v-if="item.detalle_costos && item.detalle_costos.length > 0"
                >
                  <div
                    class="subcard-header px-3 py-2 d-flex align-center justify-space-between"
                  >
                    <div class="d-flex align-center">
                      <v-icon x-small color="primary" class="mr-1"
                        >mdi-tire</v-icon
                      >
                      <span class="font-weight-bold text-caption primary--text">
                        Neumático: {{ item.num_serie }}
                      </span>
                      <v-chip
                        x-small
                        color="indigo lighten-5"
                        class="indigo--text text--darken-3 ml-2 font-weight-bold"
                      >
                        Posición: {{ item.posicion }}
                      </v-chip>
                    </div>
                  </div>

                  <div class="table-responsive-wrapper">
                    <table class="modern-dashboard-table modern-subtable">
                      <thead>
                        <tr>
                          <th class="text-center">CANT. REENCAUCHES</th>
                          <th class="text-center">TIPO</th>
                          <th class="text-center">
                            {{ retornarUnidadMedida() }} INSTALACIÓN
                          </th>
                          <th class="text-center">
                            {{ retornarUnidadMedida() }} RETIRO
                          </th>
                          <th class="text-center">
                            {{ retornarUnidadMedida() }} RECORRIDO
                          </th>
                          <th class="text-center">COSTO REENCAUCHE ($)</th>
                          <th class="text-center">
                            {{ retornarUnidadMedida() }} ACUMULADO
                          </th>
                          <th class="text-center">
                            COSTO/{{ retornarUnidadMedida() }} ACUM. ($)
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(detalle, idx) in item.detalle_costos"
                          :key="'det-cost-' + idx"
                        >
                          <td class="text-center font-weight-medium">
                            {{ detalle.vida }}
                          </td>
                          <td class="text-center">
                            <v-chip
                              x-small
                              :color="
                                detalle.tipo === 'ORIGINAL'
                                  ? 'blue lighten-5 blue--text text--darken-3'
                                  : 'orange lighten-5 orange--text text--darken-3'
                              "
                              class="font-weight-bold"
                            >
                              {{ detalle.tipo }}
                            </v-chip>
                          </td>
                          <td class="text-center">
                            {{ parseNumber(detalle.km_instalacion) }}
                          </td>
                          <td class="text-center">
                            <span
                              :class="
                                detalle.km_retiro && detalle.km_retiro > 0
                                  ? ''
                                  : 'green--text font-weight-bold'
                              "
                            >
                              {{
                                detalle.km_retiro && detalle.km_retiro > 0
                                  ? parseNumber(detalle.km_retiro)
                                  : "ACTIVO"
                              }}
                            </span>
                          </td>
                          <td class="text-center font-weight-medium">
                            {{ parseNumber(detalle.km_rendimiento) }}
                          </td>
                          <td class="text-center font-weight-medium">
                            ${{ detalle.costo_vida }}
                          </td>
                          <td class="text-center font-weight-medium">
                            {{ parseNumber(detalle.km_acumulado) }}
                          </td>
                          <td
                            class="text-center font-weight-bold teal--text text--darken-2"
                          >
                            ${{ detalle.costo_km_acumulado }}
                          </td>
                        </tr>
                        <!-- Fila de Total -->
                        <tr class="row-total-highlight">
                          <td
                            colspan="5"
                            class="text-right font-weight-bold pr-4"
                          >
                            TOTAL GENERAL:
                          </td>
                          <td
                            class="text-center font-weight-bold indigo--text text--darken-3"
                          >
                            ${{ item.costo_total }}
                          </td>
                          <td class="text-center font-weight-bold">
                            {{ parseNumber(item.km_acumulado) }}
                          </td>
                          <td
                            class="text-center font-weight-bold teal--text text--darken-3"
                          >
                            ${{ item.costo_km_acumulado }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </v-card>
          </div>
        </v-card-text>
      </v-card>
    </v-col>
  </div>
</template>

<script>
import GraficoLine from "../../components/GraficoLine.vue";
import { mapState, mapActions } from "vuex";
import Chart from "chart.js/auto";
import ChartDataLabels from "chartjs-plugin-datalabels";
Chart.register(ChartDataLabels);
import { axios2 as axios } from "@/interceptor/useApi";
import Swal from "sweetalert2";
import global from "@/global";

export default {
  components: {
    GraficoLine,
  },
  data() {
    return {
      Labels: [],
      Vehiculos: [],
      Neumaticos: [],
      Porcentaje: "0 %",
      visualizarGrafico: false,
      DatosGrafico: [],
      VehiculoSeleccionado: null,
      datosVehiculosCargados: false,
      cargandoVehiculo: false,
      switch_inspecciones: false,
      id_vehiculo: 0,
      detail_neuma: [1],
      control_neuma: [1],
      costo_neuma: [1],
      costo_km_neuma: [1],
    };
  },
  computed: {
    ...mapState("reportes", [
      "Vehiculo",
      "RemanentesLimite",
      "NeumaticosVehiculo",
      "KilometrosRecorridos",
      "InspeccionesVehiculo",
      "CostoKmAcumulado",
    ]),
    ...mapState("cliente", ["Cliente"]),
    helpdeskUrl() {
      return (global && global.helpdesk_url) ? global.helpdesk_url : '#';
    },
    costoKmAcumuladoFiltrado() {
      if (!this.CostoKmAcumulado || this.CostoKmAcumulado.length === 0) {
        return [];
      }
      return this.CostoKmAcumulado.filter((item) => {
        let activo = item.activo;
        if (activo === undefined && this.NeumaticosVehiculo) {
          const tire = this.NeumaticosVehiculo.find(
            (n) =>
              n.id_neumaticos == item.id_neumatico ||
              n.num_serie == item.num_serie,
          );
          if (tire && tire.activo !== undefined) {
            activo = tire.activo;
          }
        }
        if (activo === undefined) {
          activo = 1;
        }
        return this.costo_km_neuma.includes(activo);
      });
    },
    labelKilometrajeInicial() {
      return this.Vehiculo && this.Vehiculo.tipo_costo == 2
        ? "Horas Iniciales"
        : "Kilometraje Inicial";
    },
    labelKilometrajeActual() {
      return this.Vehiculo && this.Vehiculo.tipo_costo == 2
        ? "Horas Actuales"
        : "Kilometraje Actual";
    },
    labelKilometrajeRecorrido() {
      return this.Vehiculo && this.Vehiculo.tipo_costo == 2
        ? "Horas Recorridas"
        : "Kilometraje Recorrido";
    },
    labelScaleX() {
      return this.Vehiculo && this.Vehiculo.tipo_costo == 2
        ? "Horas"
        : "Kilómetros";
    },
    labelCostoPorUnidadAcumulativo() {
      return this.Vehiculo && this.Vehiculo.tipo_costo == 2
        ? "Costo por hora acumulativo"
        : "Costo por kilómetro acumulativo";
    },
    labelUnidadAcumulado() {
      return this.Vehiculo && this.Vehiculo.tipo_costo == 2
        ? "Hr Acumulado"
        : "Km Acumulado";
    },
  },
  methods: {
    ...mapActions("reportes", [
      "DatosGraficoCurvaRemanenteVehiculo",
      "VaciarObjetoVehiculo",
    ]),
    ...mapActions("cliente", ["ObtenerDatosCliente"]),

    messageErrorAlert: function () {
      Swal.fire({
        title: "Upps, algo paso!",
        text: "Servidor desconectado, por favor actualice la ventana!",
        icon: "error",
        showCancelButton: false,
        confirmButtonColor: "#d33",
        confirmButtonText: "Actualizar",
        showClass: {
          popup: `
            animate__animated
            animate__fadeInUp
            animate__faster
          `,
        },
        hideClass: {
          popup: `
            animate__animated
            animate__fadeOutDown
            animate__faster
          `,
        },
        backdrop: `
          rgba(255,0,0,0.1)
          left top
          no-repeat
        `,
      }).then((result) => {
        if (result.isConfirmed) {
          location.reload();
        }
      });
    },

    cargarVehiculos: async function (item) {
      this.VaciarObjetoVehiculo();
      const data = {
        id_cliente: localStorage.getItem("idcliente"),
      };
      try {
        const url = "vehiculos/showminified";
        await axios
          .post(url, data)
          .then((response) => {
            this.Vehiculos = [];
            response.data.data.forEach((element, i) => {
              this.Vehiculos.push({
                value: element.id,
                text: element.placa + "/ " + element.codigo,
              });
            });
          })
          .catch((error) => {
            console.error("error!", error);
            this.errorMessage = error.response.data;
            this.messageErrorAlert();
          });
      } catch (error) {
        console.log(error);
        this.messageErrorAlert();
      }
    },

    onSeleccionarVehiculo: async function (id) {
      this.id_vehiculo = id;
      if (id != null) {
        this.cargandoVehiculo = true;
        try {
          await this.DatosGraficoCurvaRemanenteVehiculo({
            id: id,
            inspecciones_antiguas: this.switch_inspecciones,
          });
          this.DatosGrafico = [];

          // Línea límite de remanente
          var datos = {
            label: "Remanente Límite (mm)",
            data: this.RemanentesLimite,
            borderColor: "rgba(225, 11, 50, 1)",
            backgroundColor: "rgba(225, 11, 50, 0)",
            pointBorderColor: "rgba(225, 11, 50, 0)",
            pointBackgroundColor: "rgba(225, 11, 50, 0)",
            pointBorderWidth: 0.5,
          };
          this.DatosGrafico.push(datos);

          // Líneas de cada neumático del vehículo
          this.NeumaticosVehiculo.forEach((element) => {
            var color = this.random_rgba();
            var datosTire = {
              label: element.num_serie,
              data: element.array_remanente,
              borderColor: "rgba(" + color + ",1)",
              backgroundColor: "rgba(" + color + ",0.1)",
              pointBorderColor: "rgba(" + color + ",1)",
              pointBackgroundColor: "rgba(" + color + ",1)",
              pointBorderWidth: 1,
              cubicInterpolationMode: "monotone",
              fill: true,
              spanGaps: true,
            };
            this.DatosGrafico.push(datosTire);
          });

          this.Labels = this.KilometrosRecorridos;
          this.visualizarGrafico = false;
          await this.$nextTick();
          this.visualizarGrafico = true;
          this.datosVehiculosCargados = true;

          // Renderizar gráfico de Costo por Km Acumulativo
          await this.$nextTick();
          this.renderizarGraficoCostoKmAcumulado();
        } catch (err) {
          console.error("Error al cargar datos del vehículo:", err);
        } finally {
          this.cargandoVehiculo = false;
        }
      } else {
        this.datosVehiculosCargados = false;
        this.visualizarGrafico = false;
      }
    },

    // Genera colores aleatorios
    random_rgba: function () {
      var o = Math.round,
        r = Math.random,
        s = 255;
      return o(r() * s) + "," + o(r() * s) + "," + o(r() * s);
    },

    retornarUnidadMedida: function () {
      let unidad = "Km";
      if (this.Vehiculo && this.Vehiculo.tipo_costo == 2) {
        unidad = "Hr";
      }
      return unidad;
    },

    imprimirRemanenteMenorDelVehiculo: function (item, index) {
      if (item === null || item === undefined || item === "") {
        return "-";
      }
      const remanente =
        typeof item === "object" && item !== null ? item.remanente_menor : item;

      if (
        remanente === null ||
        remanente === undefined ||
        remanente === "" ||
        remanente === "-" ||
        (typeof remanente === "string" && remanente.trim() === "")
      ) {
        return "-";
      }

      return remanente;
    },

    calcularValoresSegundaFila: function (item) {
      let remanenteoriginal = item.remanente_original_neumatico ?? 1;
      let remanenteminimo = item.min_remanente ?? 1;
      let km_recorrido = item.km_recorrido ?? 0;
      let valor = (
        km_recorrido /
        (remanenteoriginal - remanenteminimo)
      ).toFixed(2);
      if (valor == "Infinity" || isNaN(valor)) {
        return "-";
      }
      return valor;
    },

    calcularValoresTerceraFila: function (item) {
      let kmxmm = this.calcularValoresSegundaFila(item);
      if (kmxmm == "-") {
        return "-";
      }
      let remanenteoriginal = item.remanente_original_neumatico ?? 1;
      let remanente_reencauche = this.Vehiculo.remanente_reencauche ?? 1;
      let valor = (kmxmm * (remanenteoriginal - remanente_reencauche)).toFixed(
        1,
      );
      if (isNaN(valor)) {
        return "-";
      }
      return valor;
    },

    calcularValoresCuartaFila: function (item) {
      let kmxmm = this.calcularValoresTerceraFila(item);
      if (kmxmm == "No determinado" || kmxmm == "-") {
        return "No determinado";
      }
      if (
        kmxmm == "Infinity" ||
        kmxmm == 0 ||
        kmxmm == null ||
        kmxmm == undefined
      ) {
        return "0.0";
      }
      let detalle_kmmm = (item.precio_neumatico_dolares / kmxmm).toFixed(4);
      if (isNaN(detalle_kmmm)) {
        return "-";
      }
      return detalle_kmmm;
    },

    parseNumber(numberString) {
      let number = parseFloat(numberString);
      if (isNaN(number)) {
        return "-";
      }
      return number.toLocaleString("en-US", {
        minimumFractionDigits: 1,
        maximumFractionDigits: 1,
      });
    },

    renderizarGraficoCostoKmAcumulado: function () {
      // Destruir chart previo si existe
      if (this.chartCostoKmAcumInstance) {
        this.chartCostoKmAcumInstance.destroy();
        this.chartCostoKmAcumInstance = null;
      }

      if (!this.CostoKmAcumulado || this.CostoKmAcumulado.length === 0) return;

      const canvas = this.$refs.chartCostoKmAcum;
      if (!canvas) return;

      const labels = this.CostoKmAcumulado.map((item) => item.num_serie);
      const datosCostoKm = this.CostoKmAcumulado.map(
        (item) => item.costo_km_acumulado,
      );
      const datosKmAcum = this.CostoKmAcumulado.map(
        (item) => item.km_acumulado,
      );
      const datosCostoTotal = this.CostoKmAcumulado.map(
        (item) => item.costo_total,
      );

      this.chartCostoKmAcumInstance = new Chart(canvas, {
        type: "bar",
        plugins: [ChartDataLabels],
        data: {
          labels: labels,
          datasets: [
            {
              label: "Costo/Km Acumulado ($)",
              data: datosCostoKm,
              backgroundColor: "rgba(54, 162, 235, 0.7)",
              borderColor: "rgba(54, 162, 235, 1)",
              borderWidth: 1,
              yAxisID: "y",
              order: 2,
            },
            {
              label: "Km Acumulado",
              data: datosKmAcum,
              type: "line",
              borderColor: "rgba(255, 99, 132, 1)",
              backgroundColor: "rgba(255, 99, 132, 0.1)",
              pointBackgroundColor: "rgba(255, 99, 132, 1)",
              pointBorderColor: "rgba(255, 99, 132, 1)",
              pointBorderWidth: 2,
              fill: false,
              tension: 0.3,
              yAxisID: "y1",
              order: 1,
            },
            {
              label: "Costo Total ($)",
              data: datosCostoTotal,
              backgroundColor: "rgba(75, 192, 192, 0.7)",
              borderColor: "rgba(75, 192, 192, 1)",
              borderWidth: 1,
              yAxisID: "y",
              order: 3,
            },
          ],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            title: {
              display: true,
              text: "Costo por Kilómetro Acumulativo por Neumático",
              font: { size: 14 },
            },
            datalabels: {
              display: function (context) {
                return context.dataset.type !== "line";
              },
              anchor: "end",
              align: "top",
              font: { size: 10 },
              formatter: function (value) {
                return value;
              },
            },
            tooltip: {
              mode: "index",
              intersect: false,
            },
          },
          interaction: {
            mode: "index",
            intersect: false,
          },
          scales: {
            x: {
              display: true,
              title: {
                display: true,
                text: "Neumáticos (N° Serie)",
              },
            },
            y: {
              display: true,
              position: "left",
              title: {
                display: true,
                text: "Costo ($)",
              },
              suggestedMin: 0,
            },
            y1: {
              display: true,
              position: "right",
              title: {
                display: true,
                text: "Km Acumulado",
              },
              suggestedMin: 0,
              grid: {
                drawOnChartArea: false,
              },
            },
          },
        },
      });
    },
  },
  async mounted() {
    this.cargarVehiculos();
    this.chartCostoKmAcumInstance = null;
    if (!this.Cliente || !this.Cliente.razon_social) {
      try {
        await this.ObtenerDatosCliente();
      } catch (e) {
        console.log("No se pudo obtener datos del cliente:", e);
      }
    }
  },
  beforeDestroy() {
    if (this.chartCostoKmAcumInstance) {
      this.chartCostoKmAcumInstance.destroy();
    }
  },
};
</script>

<style scoped>
/* =========================================================
   UI/UX STYLES - REPORTE CURVA DE DESGASTE DE VEHÍCULO
   Basado en ReporteCurvaDesgasteNeumatico.vue y ReporteConsolidado.vue
   ========================================================= */

.curva-desgaste-wrapper {
  background-color: #f8fafc;
  min-height: 100%;
}

/* Botón Volver */
.back-btn {
  font-weight: 700;
  letter-spacing: 0.3px;
  border-radius: 8px;
  text-transform: none;
  transition: all 0.2s ease;
}

.back-btn:hover {
  transform: translateX(-2px);
}

/* Card y Header Modernos */
.modern-report-card {
  border-radius: 12px !important;
  border: 1px solid #e2e8f0 !important;
  overflow: hidden;
  background: #ffffff !important;
}

.report-header-banner {
  background: linear-gradient(135deg, #1e293b 0%, #334155 100%);
  padding: 14px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 10px;
}

.header-main-info {
  flex: 1 1 0;
  min-width: 0;
  overflow: hidden;
}

.header-text-block {
  min-width: 0;
  overflow: hidden;
}

.header-help-btn {
  flex: 0 0 auto;
  flex-shrink: 0;
  white-space: nowrap;
}

.header-icon-box {
  width: 42px;
  height: 42px;
  min-width: 42px;
  background: rgba(255, 255, 255, 0.12);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
}

.header-company-title {
  font-size: 1.05rem;
  line-height: 1.25;
  letter-spacing: 0.3px;
  color: #ffffff;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.header-report-subtitle {
  color: #94a3b8;
  font-size: 0.78rem;
  font-weight: 500;
  margin-top: 2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.vehicle-header-chip {
  background: rgba(255, 255, 255, 0.15) !important;
  border: 1px solid rgba(255, 255, 255, 0.25) !important;
  color: #ffffff !important;
  font-weight: 600;
  letter-spacing: 0.3px;
}

.btn-circle-tooltip {
  background: rgba(255, 255, 255, 0.16) !important;
  border: 1px solid rgba(255, 255, 255, 0.25) !important;
  border-radius: 50% !important;
  width: 36px !important;
  height: 36px !important;
  min-width: 36px !important;
  max-width: 36px !important;
  padding: 0 !important;
  margin: 0 !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  text-decoration: none !important;
  transition: all 0.2s ease-in-out !important;
}

.btn-circle-tooltip:hover {
  background: rgba(255, 255, 255, 0.28) !important;
  border-color: rgba(255, 255, 255, 0.45) !important;
  transform: scale(1.06);
}

/* Cards internas Dashboard */
.dashboard-chart-card {
  border: 1px solid #e2e8f0 !important;
  background-color: #ffffff;
  transition: transform 0.2s ease, box-shadow 0.25s ease, border-color 0.2s ease;
}

.dashboard-chart-card:hover {
  border-color: #cbd5e1 !important;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.05) !important;
}

.chart-subtitle-bar {
  background: linear-gradient(180deg, #f8fafc 0%, #f1f5f9 100%);
  border-bottom: 1px solid #e2e8f0;
  font-size: 0.815rem;
  line-height: 1.35;
  min-height: 42px;
}

.chart-canvas-container {
  background-color: #ffffff;
  min-height: 340px;
  position: relative;
  width: 100%;
}

/* Estados Vacío y Carga */
.chart-empty-state {
  min-height: 340px;
  background: #f8fafc;
  border: 1.5px dashed #cbd5e1;
}

.empty-state-icon-circle {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: #eff6ff;
  border: 1px solid #bfdbfe;
  display: flex;
  align-items: center;
  justify-content: center;
}

.chart-loading-state {
  min-height: 340px;
  background: #ffffff;
  border: 1px solid #e2e8f0;
}

.max-width-480 {
  max-width: 480px;
  margin-left: auto;
  margin-right: auto;
}

/* Ficha Técnica Grid */
.tire-spec-box {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 8px 12px;
  transition: all 0.2s ease;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.tire-spec-box:hover {
  background: #ffffff;
  border-color: #cbd5e1;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.04);
}

.spec-label {
  font-size: 10.5px;
  font-weight: 700;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  display: flex;
  align-items: center;
  margin-bottom: 3px;
}

.spec-value {
  font-size: 13.5px;
  color: #1e293b;
  line-height: 1.25;
}

/* Switch Moderno */
.modern-switch ::v-deep .v-input--selection-controls__input {
  margin-right: 8px !important;
}

/* Tablas Modernas */
.table-responsive-wrapper {
  overflow-x: auto;
  width: 100%;
}

.table-responsive-wrapper::-webkit-scrollbar {
  height: 6px;
}

.table-responsive-wrapper::-webkit-scrollbar-track {
  background: #f1f5f9;
}

.table-responsive-wrapper::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 4px;
}

.modern-dashboard-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  font-size: 12.5px;
}

.modern-dashboard-table thead th {
  background: linear-gradient(180deg, #f8fafc 0%, #f1f5f9 100%);
  color: #334155;
  font-weight: 700;
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  padding: 10px 14px;
  border-bottom: 2px solid #cbd5e1;
  border-top: none;
  white-space: nowrap;
}

.modern-dashboard-table tbody tr {
  transition: background-color 0.15s ease;
  border-bottom: 1px solid #e2e8f0;
}

.modern-dashboard-table tbody tr:hover {
  background-color: #f8fafc;
}

.modern-dashboard-table tbody td {
  padding: 10px 14px;
  border-bottom: 1px solid #edf2f7;
  color: #1e293b;
  vertical-align: middle;
}

/* Matriz de Controles e Inspecciones */
.modern-matrix-table thead th {
  border-right: 1px solid #e2e8f0;
}

.modern-matrix-table tbody td {
  border-right: 1px solid #edf2f7;
}

.header-matrix-group {
  background: linear-gradient(180deg, #eff6ff 0%, #dbeafe 100%) !important;
  color: #1e40af !important;
  font-weight: 800 !important;
}

.subheader-tire {
  background: #f8fafc !important;
  color: #475569 !important;
  font-size: 11.5px !important;
  font-weight: 700 !important;
}

.row-montaje {
  background-color: #f0fdf4 !important;
}

.row-montaje td {
  border-bottom: 2px solid #bbf7d0 !important;
}

.cell-freeze {
  background-color: #f8fafc;
  font-weight: 600;
}

.remanente-badge {
  display: inline-block;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  color: #1e293b;
}

/* Tabla Traspuesta */
.modern-transposed-table tbody td {
  border-right: 1px solid #edf2f7;
}

/* Sub-card de Costos por Neumático */
.cost-detail-subcard {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.03);
}

.subcard-header {
  background: linear-gradient(180deg, #f8fafc 0%, #f1f5f9 100%);
  border-bottom: 1px solid #e2e8f0;
}

.modern-subtable thead th {
  font-size: 10px !important;
  padding: 8px 10px !important;
}

.modern-subtable tbody td {
  font-size: 11.5px !important;
  padding: 8px 10px !important;
}

.row-total-highlight {
  background-color: #f8fafc !important;
  border-top: 2px solid #cbd5e1 !important;
}

/* Filtro Toggle Botones */
.status-filter-toggle {
  background: rgba(15, 23, 42, 0.05) !important;
  border: 1px solid #e2e8f0 !important;
  padding: 2px !important;
  border-radius: 9999px !important;
}

.status-filter-btn {
  border-radius: 9999px !important;
  min-height: 28px !important;
  padding: 0 12px !important;
  font-size: 12px !important;
  font-weight: 600 !important;
  color: #64748b !important;
  background: transparent !important;
  border: none !important;
  text-transform: none !important;
  transition: all 0.2s ease !important;
}

.status-btn-active--primary {
  background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%) !important;
  color: #ffffff !important;
  box-shadow: 0 2px 8px rgba(37, 99, 235, 0.35) !important;
}

/* Utilities */
.border-top-light {
  border-top: 1px solid #e2e8f0;
}

.border-bottom-light {
  border-bottom: 1px solid #e2e8f0;
}

.bg-light-neutral {
  background-color: #f8fafc;
}

.field-custom ::v-deep .v-input__slot {
  background: #f8fafc !important;
  border-radius: 8px !important;
  transition: all 0.2s ease;
}

.field-custom ::v-deep .v-input__slot:hover {
  background: #ffffff !important;
}

.field-custom ::v-deep.v-input--is-focused .v-input__slot {
  background: #ffffff !important;
}

/* ============================================================
   RESPONSIVE: Mobile (max 600px)
   ============================================================ */
@media (max-width: 600px) {
  .report-header-banner {
    padding: 12px 14px;
    gap: 8px;
  }

  .header-icon-box {
    width: 36px;
    height: 36px;
    min-width: 36px;
  }

  .header-company-title {
    font-size: 0.85rem !important;
  }

  .header-report-subtitle {
    font-size: 0.68rem !important;
  }
}
</style>
